import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertTriangle, Loader2 } from "lucide-react";

export default function DeleteUserDialog({
  delTarget,
  delStage,
  setDelStage,
  delEmail,
  setDelEmail,
  delEmailMatches,
  delBusy,
  closeDelete,
  confirmDelete,
}) {
  return (
    <Dialog open={!!delTarget} onOpenChange={(o) => (!o ? closeDelete() : null)}>
      <DialogContent data-testid="delete-user-dialog">
        {delStage === 1 ? (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-destructive" />
                Konto endgültig löschen?
              </DialogTitle>
              <DialogDescription>
                Geben Sie zur Bestätigung die E-Mail-Adresse des Nutzers ein:{" "}
                <span className="font-medium text-foreground">{delTarget?.email}</span>
              </DialogDescription>
            </DialogHeader>
            <Input
              value={delEmail}
              onChange={(e) => setDelEmail(e.target.value)}
              placeholder={delTarget?.email}
              autoComplete="off"
              data-testid="delete-user-email-input"
            />
            <DialogFooter>
              <Button variant="outline" onClick={closeDelete} data-testid="delete-user-cancel">
                Abbrechen
              </Button>
              <Button
                variant="destructive"
                onClick={() => setDelStage(2)}
                disabled={!delEmailMatches}
                data-testid="delete-user-continue"
              >
                Weiter
              </Button>
            </DialogFooter>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-destructive" />
                Letzte Warnung
              </DialogTitle>
              <DialogDescription>
                Dieses Konto und alle zugehörigen Daten werden{" "}
                <span className="font-medium text-destructive">unwiderruflich gelöscht</span> und können{" "}
                <span className="font-medium text-destructive">nicht wiederhergestellt</span> werden. Beim
                Bestätigen werden zunächst alle Belege (PDF + CSV) samt Kundendaten als ZIP
                heruntergeladen, danach erfolgt die endgültige Löschung.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={() => setDelStage(1)} data-testid="delete-user-back">
                Zurück
              </Button>
              <Button
                variant="destructive"
                onClick={confirmDelete}
                disabled={delBusy}
                data-testid="delete-user-confirm"
              >
                {delBusy ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  "Exportieren & endgültig löschen"
                )}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
